import GlobalModal from "../../GlobalModal/Modal/GlobalModal";
import QucikReplyCard from "../../QuickReplyCard";
import GlobalCustomFieldGrouped from "../../GlobalCustomFieldGrouped/Index";
const LinkFile = {
    'modal' : GlobalModal,
    'QucikReplyCard': QucikReplyCard,
    'GlobalCustomFieldGrouped': GlobalCustomFieldGrouped,
}
export default LinkFile;